import { Theme } from '@/helpers/types'

const themes: Record<string, Theme> = {
  '08070543': {
    brandColor: '#4ba82e',
    brandFont: 'SkodaPro-Regular.ttf',
    brandLogo: 'Logo_Skoda.svg'
  },
  '0BA9M897': {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: ''
  },
  '11A0B8F6': {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: 'Logo_Honda_Coches.svg'
  },
  '1533AD1F': {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  '179A9464': {
    brandColor: '#272727',
    brandFont: 'AudiType-Normal.ttf',
    brandLogo: 'Logo_Audi.svg'
  },
  '21EDE960': {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  '273235BF': {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: 'Logo_Hyundai.svg'
  },
  '2DF5DC1F': {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: 'Logo_DS.svg'
  },
  '33A91CE7': {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  '3IHCMZHX': {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  '46FBA93F': {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: 'Logo_Seat.svg'
  },
  '48E76FDC': {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: 'Logo_Citroen.svg'
  },
  '4C2A1781': {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: 'Logo_Cupra.svg'
  },
  '4FAD4028': {
    brandColor: '#272727',
    brandFont: '',
    brandLogo: 'Logo_MyCarFlix.svg'
  },
  52312411: {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: 'Logo_Honda_Motos.svg'
  },
  '56B6E050': {
    brandColor: '#272727',
    brandFont: 'AudiType-Normal.ttf',
    brandLogo: 'Logo_Audi.svg'
  },
  '5B610040': {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: 'Logo_Seat.svg'
  },
  '636E04D1': {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: ''
  },
  '759263CD': {
    brandColor: '#272727',
    brandFont: 'AudiType-Normal.ttf',
    brandLogo: 'Logo_Audi.svg'
  },
  '89957F18': {
    brandColor: '#272727',
    brandFont: 'AudiType-Normal.ttf',
    brandLogo: 'Logo_Audi.svg'
  },
  '94250E25': {
    brandColor: '#4ba82e',
    brandFont: 'SkodaPro-Regular.ttf',
    brandLogo: 'Logo_MyCarFlix.svg'
  },
  '999800D2': {
    brandColor: '#272727',
    brandFont: '',
    brandLogo: 'Logo_Ducati.svg'
  },
  99999999: {
    brandColor: '#272727',
    brandFont: '',
    brandLogo: 'Logo_Ducati.svg'
  },
  '9C8190EC': {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  B8A37672: {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: 'Logo_MyCarFlix.svg'
  },
  D0519731: {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_MyCarFlix.svg'
  },
  D749E67C: {
    brandColor: '#1976d2',
    brandFont: '',
    brandLogo: 'Logo_MyCarFlix.svg'
  },
  '6A19F31E': {
    brandColor: '#C3002F',
    brandFont: '',
    brandLogo: 'Logo_Nissan.svg'
  },
  D9FEECAB: {
    brandColor: '#272727',
    brandFont: '',
    brandLogo: 'Logo_MyCarFlix.svg'
  },
  default: {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: ''
  },
  ECC3A49E: {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  F49CB785: {
    brandColor: '#0099da',
    brandFont: 'VWTextOffice-Regular.ttf',
    brandLogo: 'Logo_Volkswagen.svg'
  },
  JX4HJNC8: {
    brandColor: '#ffcc00',
    brandFont: '',
    brandLogo: 'Logo_Xtravans.svg'
  },
  KAOTR3I0: {
    brandColor: '#0099da',
    brandFont: '',
    brandLogo: 'Logo_Cupra.svg'
  }
}

export default themes
